import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76567c24")

_pushScopeId("data-v-76567c24")
const _hoisted_1 = { class: "p-mt-2 p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-12" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = { class: "node-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Tree = _resolveComponent("Tree")
  const _component_HierarchyManagementNodeDetailDialog = _resolveComponent("HierarchyManagementNodeDetailDialog")
  const _component_HierarchyManagementHierarchiesTargetDialog = _resolveComponent("HierarchyManagementHierarchiesTargetDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("form", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, [
          _createVNode(_component_Dropdown, {
            class: "kn-material-input",
            modelValue: _ctx.orderBy,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.orderBy = $event)),
            options: _ctx.hierarchyManagementHierarchiesTreeDescriptor.orderByOptions,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortTree(_ctx.nodes)))
          }, null, 8, ["modelValue", "options"]),
          _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.orderBy') + ' ... '), 1)
        ])
      ])
    ]),
    _createVNode(_component_Tree, {
      class: "hierarchies-tree p-col-12",
      value: _ctx.nodes,
      filter: true,
      filterMode: "lenient"
    }, {
      default: _withId((slotProps) => [
        _createVNode("div", {
          class: ["p-d-flex p-flex-row p-ai-center", { dropzone: _ctx.dropzoneActive[slotProps.node.key] }],
          draggable: !slotProps.node.data.root,
          onDragstart: _withModifiers(($event: any) => (_ctx.onDragStart($event, slotProps.node)), ["stop"]),
          onMouseover: ($event: any) => (_ctx.buttonVisible[slotProps.node.key] = true),
          onMouseleave: ($event: any) => (_ctx.buttonVisible[slotProps.node.key] = false),
          onDrop: _withModifiers(($event: any) => (_ctx.onDragDrop($event, slotProps.node, slotProps.node.key)), ["stop"]),
          onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
          onDragenter: _withModifiers(($event: any) => (_ctx.setDropzoneClass(true, slotProps.node)), ["prevent"]),
          onDragleave: _withModifiers(($event: any) => (_ctx.setDropzoneClass(false, slotProps.node)), ["prevent"])
        }, [
          _createVNode("span", _hoisted_5, _toDisplayString(slotProps.node.label), 1),
          _withDirectives(_createVNode("div", null, [
            (_ctx.treeMode !== 'info')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  (slotProps.node.leaf)
                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "pi pi-clone",
                        class: "p-button-link p-button-sm p-p-0",
                        onClick: _withModifiers(($event: any) => (_ctx.cloneNode(slotProps.node)), ["stop"])
                      }, null, 8, ["onClick"])), [
                        [
                          _directive_tooltip,
                          _ctx.$t('common.clone'),
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _withDirectives((_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        icon: "pi pi-plus",
                        class: "p-button-link p-button-sm p-p-0",
                        onClick: _withModifiers(($event: any) => (_ctx.addNode(slotProps.node)), ["stop"])
                      }, null, 8, ["onClick"])), [
                        [
                          _directive_tooltip,
                          _ctx.$t('common.add'),
                          void 0,
                          { top: true }
                        ]
                      ]),
                  (!slotProps.node.data.root)
                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                        key: 2,
                        icon: "pi pi-pencil",
                        class: "p-button-link p-button-sm p-p-0",
                        onClick: _withModifiers(($event: any) => (_ctx.editNode(slotProps.node)), ["stop"])
                      }, null, 8, ["onClick"])), [
                        [
                          _directive_tooltip,
                          _ctx.$t('common.edit'),
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _createCommentVNode("", true),
                  (!slotProps.node.data.root)
                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                        key: 3,
                        icon: "pi pi-trash",
                        class: "p-button-link p-button-sm p-p-0",
                        onClick: _withModifiers(($event: any) => (_ctx.deleteNodeConfirm(slotProps.node)), ["stop"])
                      }, null, 8, ["onClick"])), [
                        [
                          _directive_tooltip,
                          _ctx.$t('common.delete'),
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-info",
              class: "p-button-link p-button-sm p-p-0",
              onClick: _withModifiers(($event: any) => (_ctx.showNodeInfo(slotProps.node)), ["stop"])
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('common.detail'),
                void 0,
                { top: true }
              ]
            ])
          ], 512), [
            [_vShow, _ctx.buttonVisible[slotProps.node.key]]
          ])
        ], 42, ["draggable", "onDragstart", "onMouseover", "onMouseleave", "onDrop", "onDragenter", "onDragleave"])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_HierarchyManagementNodeDetailDialog, {
      visible: _ctx.detailDialogVisible,
      selectedNode: _ctx.selectedNode,
      metadata: _ctx.metadata,
      mode: _ctx.mode,
      onSave: _ctx.onNodeSave,
      onClose: _ctx.closeNodeDialog
    }, null, 8, ["visible", "selectedNode", "metadata", "mode", "onSave", "onClose"]),
    _createVNode(_component_HierarchyManagementHierarchiesTargetDialog, {
      visible: _ctx.targetDialogVisible,
      hierarchiesTargets: _ctx.relations,
      onClose: _ctx.closeTargetDialog,
      onSave: _ctx.onTargetsSave
    }, null, 8, ["visible", "hierarchiesTargets", "onClose", "onSave"])
  ]))
})